var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFuture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#e1e1e1;stroke-linecap:round;stroke-linejoin:round;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.374,27.269c-.64-.8645-.9217-1.1515-2.1342.3159s-2.1208-.1069-2.7783-2.56l-1.34-5L18.0658,18.07A10.6535,10.6535,0,0,1,23.98,7.0585,10.6537,10.6537,0,0,1,29.895,18.07l1.9442,1.9548-1.34,5c-.6575,2.4536-1.5657,4.0278-2.7783,2.56s-1.494-1.18-2.1342-.3159-.9558,1.294-1.6065,1.294-.9663-.4294-1.6065-1.294Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.458,26.557s.0346,5.6039-2.2508,7.7421c0,0-4.0339-.897-4.4986,2.764H12.5965a1.3137,1.3137,0,0,0-1.388-.8013h-2.75c-.2748.0131-.7575.1151-1.1349,1.3076"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.734,26.638a12.9764,12.9764,0,0,0,1.5511,6.4829s5.2185-1.85,6.2769,3.9956a1.7249,1.7249,0,0,0,1.9467,0s.1-.8791.8792-.8791h2.96a.7348.7348,0,0,1,.7854.7512"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.935,27.993s.4706,5.6292-2.0359,9.2768H19.3346A1.9621,1.9621,0,0,0,17.2688,39.32c-1.4409.6442-1.0981-.6809-2.4131-.7158-1.26,0-2.9863-.1636-2.9863,1.9551,0,0-1.3616-.4277-1.4049.1441"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.166,27.825s.1371,5.649,1.6953,8.2661H29.856A1.924,1.924,0,0,1,31.73,37.9649c0,1.7745,1.0333,1.2908,1.0333,1.2908s-.1928-.633,1.7355-.633,2.5481.9556,2.5481,1.8927l.702.0137"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.95,25.405a49.532,49.532,0,0,1-1.5628-5.1428"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.011,25.405a49.532,49.532,0,0,0,1.5628-5.1428"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 23.981,
    cy: 14.405,
    r: 1.9625
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 24,
    cy: 24,
    r: 21.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuture);
export default __webpack_public_path__ + "static/media/future.3c9309851cdab8e6ac15de33593311cd.svg";
export { ForwardRef as ReactComponent };